import React, { useEffect } from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { Typography } from '../../../components/atoms';
import { LoadingSpinner } from '../../../components/layouts';

const useStyles = makeStyles((theme: Theme) => ({
  orderProcessing: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    justifyContent: 'center',
  },
  spinner: {
    height: 'auto',

    '& svg': {
      color: theme.palette.primary.main,
    },
  },
  subText: {
    marginTop: theme.spacing(0.5),
    textAlign: 'center',
  },
  title: {
    marginTop: theme.spacing(3.5),
    textAlign: 'center',
  },
}));

type Props = {
  mainText: string;
  subText: string;
};

export function OrderProcessing({ mainText, subText }: Props): JSX.Element {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.orderProcessing} data-fd="order-processing">
      <LoadingSpinner className={classes.spinner} />
      <Typography className={classes.title} variant="h2">
        {mainText}
      </Typography>
      <Typography className={classes.subText}>{subText}</Typography>
    </div>
  );
}
